const GUEST_CART_USER_KEY = "guestCartUserId";

function createGuestCartUserId() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return `guest_${crypto.randomUUID()}`;
  }

  return `guest_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

export function getCartUserId() {
  const savedUserId = localStorage.getItem("userId");
  if (savedUserId && savedUserId.trim()) {
    return savedUserId;
  }

  let guestCartUserId = localStorage.getItem(GUEST_CART_USER_KEY);
  if (!guestCartUserId) {
    guestCartUserId = createGuestCartUserId();
    localStorage.setItem(GUEST_CART_USER_KEY, guestCartUserId);
  }

  return guestCartUserId;
}
